import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import AppMenu from '../../../../../../components/common/AppMenu';
import {SVG} from '../../../../../../constants/assetLists';
import AppTabs from '../../../../../../components/common/AppTabs';
import { useFormsContext } from '../../../../../../context/forms/FormsContextProvider';

type Props = {
  onPrint: () => void;
};

function ResponseHeader({onPrint}: Props) {
  const {t} = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { selectedResponseTab, setSelectedResponseTab } = useFormsContext();

  const MENU_ITEMS = [
    {
      title: t('forms.dialog.responses.print'),
      value: 'print',
      icon: SVG.printerBlackIcon,
    },
    {
      title: t('forms.dialog.responses.share'),
      value: 'share',
      icon: SVG.shareDarkIcon,
    },
  ];

  const tabItems = [
    {
      label: t("forms.dialog.responses.tabs.byQuestion"),
      value: "question",
    },
    {
      label: t("forms.dialog.responses.tabs.byResponder"),
      value: "responder",
    },
  ];

  const handleMenuItemClick = (value: string) => {
    if (value === 'print') {
      onPrint();
    }
    // Share is a placeholder for future WhatsApp integration
  };

  const handleTabChange = (value: string) => {
    setSelectedResponseTab(value);
  }

  return (
    <div className="flex justify-between items-center flex-shrink-0">
      <h2 className="text-[32px] font-normal text-black">
        {t('forms.dialog.responses.title')}
      </h2>

      <AppTabs tabs={tabItems} selected={selectedResponseTab} onChange={handleTabChange} />

      <AppMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onOpen={e => setAnchorEl(e.currentTarget as HTMLElement)}
        onClose={() => setAnchorEl(null)}
        items={MENU_ITEMS}
        onItemClick={handleMenuItemClick}
        itemIconWidth={20}
        itemIconHeight={20}
      />
    </div>
  );
}

export default ResponseHeader;
